import { Option } from '@spike/model';

/**
 * Display order for commission categories:
 * 1. Products
 * 2. Add-Ons
 * 3. Grooming
 * 4. Dental
 * 5. All other services
 *
 * Categories that don't match any known group keep their original
 * relative order and are rendered last.
 */
const categoryRank = (name: string): number => {
    const normalized = name.toLowerCase();

    if (normalized.includes('product')) {
        return 0;
    }

    if (normalized.includes('add-on') || normalized.includes('add on') || normalized.includes('addon')) {
        return 1;
    }

    if (normalized.includes('grooming')) {
        return 2;
    }

    if (normalized.includes('dental')) {
        return 3;
    }

    return 4;
};

export const sortByCommissionCategoryOrder = <T extends { category: Option<string> }>(items: Array<T>): Array<T> =>
    [...items].sort((a, b) => categoryRank(a.category.name) - categoryRank(b.category.name));

export const sortCommissionCategories = (categories: Array<Option<string>>): Array<Option<string>> =>
    [...categories].sort((a, b) => categoryRank(a.name) - categoryRank(b.name));
